export default "__VITE_ASSET__Bf6RTMe9__"